import StorageUtils from '../../common/StorageUtils';
let defaultUserSelect = {
    tagNames: -1,
    tag: -1,
    days: -1,
    weeks: -1,
    selectMap: -1,
    startDate: -1,
    endDate: -1,
    accurateDateNames: -1
};

let emptySelect = {
    tagNames: '',
    tag: '',
    days: '',
    weeks: '',
    selectMap: [],
    startDate: '',
    endDate: '',
    accurateDateNames: ''
};

let defaultDay = '2-15';

export default {
    // 定义一个用户选择的结构
    userSelect: emptySelect,
    defaultUserSelect: defaultUserSelect,

    storageMap: {
        userSelected: 'filterUserSelect'
    },


    async setSelectedDataStorage (selectedData) {
        let storeName = this.storageMap.userSelected;
        StorageUtils.setItem(storeName, JSON.stringify(selectedData));
    },

    async getSelectedDataStorage () {
        let storeName = this.storageMap.userSelected;
        return await StorageUtils.getItem(storeName);
    },

    async calcUserSelect (filterData) {
        // 默认值
        let defaultData = this.getDefaultUserSelect(filterData);

        // 缓存
        let storageData = await this.getStorageUserSelect(filterData);

        let userSelect = Object.assign({}, this.userSelect);

        Object.keys(userSelect).forEach((key) => {
            userSelect[key] = storageData[key] || defaultData[key];
        });

        if(parseInt(userSelect.tag) === -1) {
            userSelect.tagNames = '';
            userSelect.days = '2-15';
            userSelect.weeks = '';

        } else {
            // 校正userSelect的tag，因为单程往返中相同的tagNames 的tag是不同的
            let tagNamesArr = userSelect.tagNames.split('、') || [];
            let tagArr = [];
            filterData.months.forEach((item) => {
                if (tagNamesArr.indexOf(item.text) > -1 && item.text !== '自定义') {
                    tagArr.push(item.value);
                }
            });
            userSelect.tag = tagArr.length ? tagArr.join('、') : userSelect.tag;
        }



        return userSelect;
    },

    getDefaultUserSelect (filterData) {
        const {months} = filterData || {};
        let tagNamesArr = [];
        let tag = [];
        months && months.map((item) => {
            const {areDefault, text, value} = item || {};
            if (areDefault) {
                tagNamesArr.push(text);
                tag.push(value);
            }
        });

        let tagNames = tagNamesArr.join('、');

        let defaultData = {
            tagNames: tagNames,
            tag: tag.join('、'),
            days: defaultDay,
            weeks: '',
            selectMap: {}
        };
        return defaultData;
    },

    async getStorageUserSelect (filterData) {
        let userSelectStorage = await this.getSelectedDataStorage();
        let userSelect = userSelectStorage && JSON.parse(userSelectStorage);
        // 校验selectedTag的可用性
        let storageData = this.getUsableUserSelect(userSelect, filterData);
        if (storageData.days) {
            let day = storageData.days;
            storageData.days = parseInt(day) === -1 ? defaultDay : day;
        }
        return storageData;
    },

    getSelectedWeeks(usableWeeks, userSelect) {
        let {weeks} = userSelect;
        return usableWeeks.filter((week) => {
            return weeks.indexOf(week) > -1
        })
    },

    getSelectDays (userSelect) {
        let {days = '2-15'} = userSelect;
        let dayArr = days.split('-');

        return {
            start: dayArr[0],
            end: dayArr[1]
        }
    },

    getSelectedMonths (filterData, userSelect) {
        const {months} = filterData || {};
        const {tagNames} = userSelect;
        return months.filter((month) => {
            return tagNames.split('、').some((tag) => {
                return tag === month.text;
            })
        })
    },

    // 获取可以点击的weeks
    getUsableWeeks (months, tagNamesArr) {
        return Object.keys(this.getUsableWeeksMap(months, tagNamesArr));
    },

    getUsableWeeksMap (months, tagNamesArr) {
        let weeksMap = {};
        // 取并集
        months.map((item) => {
            const {text} = item || {};
            if (tagNamesArr.indexOf(text) > -1) {
                let curWeeks = item.weeks || [];
                curWeeks.map((week) => {
                    weeksMap[week] = true;
                });
            }
        });
        return weeksMap;
    },

    // 根据filterData， 判断selectedTag是否过期
    getUsableUserSelect (selectTagFromStorage, filterData) {
        if (!filterData) {
            return {};
        }

        if (!selectTagFromStorage) {
            return {};
        }
        let {tag, startDate, tagNames} = selectTagFromStorage;

        if (!tag || parseInt(tag) === -1) {
            // 没tag表示自定义，用start判断，与当前时间比
            startDate = startDate && startDate.split('|')[0];
            let startTime = new Date(startDate);
            startTime.setHours(23, 59, 59, 999);

            // 判断缓存是否过期
            if ((startTime && startTime < new Date()) || isNaN(startTime.getTime())) {
                selectTagFromStorage = {};
            }
        } else {
            // 有tag 就用tag判断， 与当前时间比

            let filterTagNamesArr = [];
            let tagArr = tag ? tag.split('、') : [];
            let tagNamesArr = tagNames ? tagNames.split('、') : [];

            filterData.months.forEach((month) => {
                filterTagNamesArr.push(month.text);
            });

            let disable = false;
            tagArr.map((tag, i) => {
                let tags = tag && tag.split(':')[0];
                let endDate = tags && tags.split('|')[1];
                let tagName = tagNamesArr[i];
                let endTime = new Date(endDate);
                endTime.setHours(23, 59, 59, 999);

                if (filterTagNamesArr.indexOf(tagName) > -1) {
                    if (endTime && !isNaN(endTime.getTime()) && endTime < new Date()) {
                        disable = true;
                    }
                } else {
                    disable = true;
                }
            });

            // 判断是否有未过期的缓存
            if (disable) {
                selectTagFromStorage = {};
            }
        }
        return selectTagFromStorage;
    }
};
